import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SORActions } from './sor.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { SorService } from '@core/services/sor.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SOREffects {
  private actions$ = inject(Actions);
  private SORService = inject(SorService);
  private translateService = inject(TranslateService);
  getSORs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SORActions.loadSORs),
      mergeMap((data) =>
        this.SORService.getSORs(data).pipe(
          map((sor) =>
            sor.success
              ? SORActions.loadSORsSuccess(sor)
              : SORActions.loadSORsFailure(sor)
          ),
          catchError((error) =>
            of(
              SORActions.loadSORsFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addSOR$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SORActions.addEditSOR),
      mergeMap((data) =>
        this.SORService.addSOR(data).pipe(
          map((SOR) => {
            if (SOR.success)
              return data.id
                ? SORActions.updateSORSuccess(SOR)
                : SORActions.addSORSuccess(SOR);
            else return SORActions.addSORFailure(SOR);
          }),
          catchError((error) =>
            of(
              SORActions.addSORFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SORActions.deleteSOR),
      mergeMap((data) =>
        this.SORService.deleteSOR(data.id).pipe(
          map((response: any) =>
            response.body.success
              ? SORActions.deleteSORSuccess({
                  ...response.body,
                  id: data.id,
                })
              : SORActions.deleteSORFailure(response.body)
          ),
          catchError((error) =>
            of(
              SORActions.deleteSORFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
